import React from "react";

function BooleanIcon() {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#000000">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path d="M3.75 10H1V5H0v13h3.75A1.251 1.251 0 0 0 5 16.75v-5.5A1.251 1.251 0 0 0 3.75 10zM4 16.75a.25.25 0 0 1-.25.25H1v-6h2.75a.25.25 0 0 1 .25.25zM10.75 10h-2.5A1.251 1.251 0 0 0 7 11.25v5.5A1.251 1.251 0 0 0 8.25 18h2.5A1.251 1.251 0 0 0 12 16.75v-5.5A1.251 1.251 0 0 0 10.75 10zm.25 6.75a.25.25 0 0 1-.25.25h-2.5a.25.25 0 0 1-.25-.25v-5.5a.25.25 0 0 1 .25-.25h2.5a.25.25 0 0 1 .25.25zM17.75 10h-2.5A1.251 1.251 0 0 0 14 11.25v5.5A1.251 1.251 0 0 0 15.25 18h2.5A1.251 1.251 0 0 0 19 16.75v-5.5A1.251 1.251 0 0 0 17.75 10zm.25 6.75a.25.25 0 0 1-.25.25h-2.5a.25.25 0 0 1-.25-.25v-5.5a.25.25 0 0 1 .25-.25h2.5a.25.25 0 0 1 .25.25zm4 .25h2v1h-3V6h-1V5h2z"></path>
        <path fill="none" d="M0 0h24v24H0z"></path>
      </g>
    </svg>
  );
}

export default BooleanIcon;
